import './Login.css'
import React from 'react'

let origin = window.location.origin
origin = origin.replace(/:3000/, '')

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  render = () => {
    return (
      <div className='login'>
        <div className='title'>Log in</div>
        <form className='form' onSubmit={this.submitLogin}>
          <label htmlFor='username'>Username:</label>
          <input id='username' />
          <label htmlFor='password'>Password:</label>
          <input id='password' type='password' />
          <input className='submit' type='submit' value='Submit' />
        </form>
        <div className='error'>{this.state.error}</div>
      </div>
    )
  }

  submitLogin = async (e) => {
    e.preventDefault()

    const username = document.getElementById('username').value
    const password = document.getElementById('password').value
    const response = await fetch(`${origin}/api/shopping_list/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: username,
        password: password,
      })
    })

    if (response.ok) {
      const token = await response.json().then(r => r.token)
      this.props.setUsernameAndToken(username, token)
    }
    else {
      this.setState({ error: await response.text() })
    }
  }
}

export default Login